/**
 * @prop --wf-footer-sitemap-row-headline-color: The color of the box title, default (--mdc-theme-accent).
 * @prop --wf-footer-sitemap-row-section-item-hover-color: The hover color of the section item, default (--mdc-theme-accent).
 * @prop --wf-footer-sitemap-row-headline-font-size: The font size of the title.
 * @prop --wf-footer-sitemap-row-headline-font-weight: The font weight of the title.
 */

:host {
    display: block;

    --border-width: 2px;
}

a {
    text-decoration: none;
    color: currentcolor;

    &:hover {
        color: var(--mdc-theme-accent);
    }
}

.wf-footer-sitemap-row {
    padding: 0 16px;
    display: grid;
    grid-template-columns: 1fr;
    line-height: 1.5;
    font-size: 1rem;

    .column {
        .section {
            border-top: var(--border-width) solid var(--wf-footer-section-divider-color);
            padding: 24px 0;

            img {
                margin-top: 8px;
            }
        }

        button.title {
            width: 100%;
            padding: 0;
            background: none;
            border: none;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                line-height: 1.71;
                font-size: var(--wf-footer-sitemap-row-headline-font-size, 1rem);
                font-weight: var(--wf-footer-sitemap-row-headline-font-weight, bold);
                margin-bottom: 4px;
                color: var(--wf-footer-section-title-color);

                &.placeholder {
                    height: 1.71em;
                }
            }
        }
    }

    a, span {
        display: block;
    }
}

@media screen and (max-width: 768px) {
    .group .column:not(.grouped) {
        display: none;
    }

    .column .section {
        cursor: pointer;

        .content, vx-icon {
            transition: transform, max-height;
            transition-duration: var(--transition-duration, 0.2s);
        }

        .content {
            overflow: hidden;
            height: 100%;
            max-height: 500px;
            line-height: 1.71;
            font-size: var(--wf-footer-sitemap-row-content-font-size, 0.9rem);
        }

        vx-icon {
            transform: rotate(180deg);
        }

        &.collapsed {
            .content {
                max-height: 0;
            }

            vx-icon {
                transform: rotate(0);
            }
        }
    }
}

@media screen and (min-width: 769px) {
    .wf-footer-sitemap-row {
        gap: 32px;
        grid-template-columns: repeat(4, 1fr);

        &:not(:last-child) {
            border-bottom: 1px solid var(--wf-footer-section-divider-color);
        }

        .column.grouped {
            display: none;
        }

        .content {
            line-height: 1.5;
            font-size: var(--wf-footer-sitemap-row-content-font-size-large, 1rem);
        }

        .column {
            padding: 24px 0;
            display: flex;
            flex-direction: column;
            gap: 24px;

            .section {
                padding: 0;
                border: none;
            }

            .title {
                vx-icon {
                    display: none;
                }

                span {
                    color: var(--wf-footer-sitemap-row-headline-color, var(--mdc-theme-accent));
                }
            }
        }

    }
}

@media screen and (min-width: 992px){
    .wf-footer-sitemap-row {
        padding-left: 80px;
        padding-right: 80px;
    }
}
